import { type QueryClient } from "@tanstack/react-query";

import { GET_WORKER_REQUIREMENTS_URL } from "./useGetWorkerRequirements";

export async function invalidateWorkerRequirements(queryClient: QueryClient) {
  await queryClient.invalidateQueries({
    queryKey: [GET_WORKER_REQUIREMENTS_URL],
  });
}
